export default __webpack_public_path__ + "locales/el-GR/InfoPanel.json?hash=f29124d6c88ef8da44b8e334ba10db76";